import { useQuery } from "@tanstack/react-query";
import { fetchHomeDashboard } from "./home-dashboard.api";
import { keys } from "./keys";

export const useHomeDashboardQuery = (payload) => {
    return useQuery({
        queryKey: keys.home.dashboard(payload),
        queryFn: () => fetchHomeDashboard(payload),
        placeholderData: (prev) => prev,
        staleTime: 30_000
    });
};
